import { LINK_PRE_PATH } from 'constants/solution';
export const urlPre = 'https://sdk-source.xylink.com/website/assets/sdk_api/';

export const PAGESIZE = 6;
export const firstPageIndex = 1;

// 多维场景，广泛应用
export const scenes = [
  {
    title: '指挥调度',
    desc: '适应弱网环境，快速接入多种前端设备，支持无限分屏，还原现场实况',
  },
  {
    title: '协同办公',
    desc: '支持多人进行音频、视频、桌面共享、白板书写、批注等办公协作应用',
  },
  {
    title: '视频客服',
    desc: '升级语音客服为视频客服并无缝嵌入业务端，实现专属服务的升级',
  },
  {
    title: '远程庭审',
    desc: '原告被告双方在线上即可出庭，全面提升审判效率',
  },
  {
    title: '活动直播',
    desc: '为企业提供稳定、快速、流畅的直播，实现直播公告、互动、投票等应用',
  },
  {
    title: '在线教育',
    desc: '支持万方接入，可快速搭建线上云课堂平台，实现大规模在线教学',
  },
];

// 开放集成 ，大有作为
export const advantages = [
  {
    title: '功能丰富',
    desc: ['以先进的编解码技术和架构级安全保障为支撑，会议、直播、录制等能力全覆盖', '支持多种布局模式、电子白板、内容共享、会议控制管理、会议查询统计、音视频质量查询等完善功能'],
    icon: urlPre + 'adv0.png',
  },
  {
    title: '全平台支持',
    desc: ['软硬件无缝接入系统，Android、iOS、Windows、Web、Electron、macOS、小程序等全平台的SDK便于开发者集成', '支持不同平台的互通，适配各种应用场景，构建广泛的应用体验'],
    icon: urlPre + 'adv1.png',
  },
  {
    title: '便捷集成',
    desc: ['通过API和SDK，轻量级开发快速实现音视频能力融入业务系统', '同时提供多样化集成部署方案，支持公有云、私有云、混合云等多种部署方式'],
    icon: urlPre + 'adv2.png',
  },
];

// 多种对接方式
export const dockingWays = [
  { icon: urlPre + 'way0.png', title: '服务端API', desc: '提供音视频全流程平台服务及功能接口，助力实现业务系统的无缝对接' },
  { icon: urlPre + 'way1.png', title: '终端SDK', desc: '提供手机、电脑、Web网页、微信小程序及硬件终端等多种终端SDK，快速实现终端音视频能力融合应用' },
];

// 一路相伴
export interface Case {
  title: string;
  desc: string;
  link: string;
  logo: string;
  grayLogo: string;
  img: string;
}

export const cases: Case[] = [
  {
    title: '中华人民共和国水利部',
    desc: '中华人民共和国水利部携手小鱼易连打造全信创的水利部指挥调度云视频系统，实现纵向覆盖部-省-市-县四级单位，横向打通相关政府业务单位和部门，助力水利治理、防汛抗旱等云上协同管理。云视频超强的融合能力，打通了监控和各部门的专业系统，满足水利部防汛应急指挥、日常会议会商、远程督查等场景的广泛应用，让联动更高效。',
    link: LINK_PRE_PATH + 'd03aba',
    logo: urlPre + 'cases/color/shuili.png',
    grayLogo: urlPre + 'cases/gray/shuili.png',
    img: urlPre + 'cases/shuili.jpg',
  },
  {
    title: '贵州省应急管理厅',
    desc: '贵州省应急管理厅，应用小鱼易连云视频，建立覆盖省委、省政府应急指挥中心、10个州市应急指挥中心、88个县级指挥中心和若干企业的省视频应急调度系统。小鱼易连开放的API/SDK能力，已经打通贵州省联合应急宝APP，安全、快速、高效地满足全省各级单位的视频会商、移动应急指挥、远程培训的多场景及大规模应用，提升全省应急事件的响应能力。',
    link: LINK_PRE_PATH + '1081',
    logo: urlPre + 'cases/color/yingji.png',
    grayLogo: urlPre + 'cases/gray/yingji.png',
    img: urlPre + 'cases/yingji.jpg',
  },
  {
    title: '北京互联网法院',
    desc: '小鱼易连携手华宇为北京互联网法院提供全套“面对面”及“键对键”司法信息服务，贯穿“云+端”全场景，支持多终端接入、SDK深度集成，完成产业链下沉，全面拓展应用场景，实现案件受理、送达、调解、证据交换、庭前准备、庭审、宣判等诉讼环节全程网络化，为司法赋能。',
    link: LINK_PRE_PATH + 'ce972e',
    logo: urlPre + 'cases/color/fayuan.png',
    grayLogo: urlPre + 'cases/gray/fayuan.png',
    img: urlPre + 'cases/fayuan.jpg',
  },
  {
    title: '山西省人民检察院',
    desc: '小鱼易连的超融合云视频平台以开放、互联能力，与山西省人民检查院现有业务系统、传统视频会议终端、云视频会议终端进行全打通，并满足API和SDK的全开放嵌入，支持将高清互动的音视频全打通到省检察院现有业务APP中，实现智慧检务业务沟通直达干警桌面，满足相关业务部门、区县检察机关的快速便捷接入，随时开启可视化的高清互动沟通和协作。',
    link: LINK_PRE_PATH + '9f0e0e',
    logo: urlPre + 'cases/color/jianchayuan.png',
    grayLogo: urlPre + 'cases/gray/jianchayuan.png',
    img: urlPre + 'cases/jianchayuan.jpg',
  },
  {
    title: '中国电子信息产业集团有限公司',
    desc: '中国电子联合小鱼易连打造面向全集团的数字CEC视频能力平台，采用“云（信创电子云）+网（SD-WAN+互联网）+超融合平台+端（蓝信端+麒麟信创端+小鱼4K硬件终端及外部移动端）”为基础设施，提供云协作、云视讯、云融合、云直播、云录播、云监控、云AI等服务，有效支撑集团各级单位的日常会议、协同办公、智慧党建、跨国海外同传会议等多场景创新应用。',
    link: LINK_PRE_PATH + '1075',
    logo: urlPre + 'cases/color/dianzi.png',
    grayLogo: urlPre + 'cases/gray/dianzi.png',
    img: urlPre + 'cases/dianzi.jpg',
  },
  {
    title: '中国海洋石油集团有限公司',
    desc: '中国海油应用小鱼易连云视频打造了融合通信云平台，实现全集团的互联互通、促进行政会议的有效向下覆盖。基于小鱼易连强大的融合能力，中国海油融合通信云平台兼容了监控和电话会议系统，满足同声传译和实时转写会议纪要等功能，也打通了中国海油的用户认证系统，实现双因素认证登陆，搭配统一管控的管理平台，满足会议的分级管理，实现全集团各级各部门的高效协同办公和多业务场景的可视化联动。',
    link: LINK_PRE_PATH + '1083',
    logo: urlPre + 'cases/color/haiyou.png',
    grayLogo: urlPre + 'cases/gray/haiyou.png',
    img: urlPre + 'cases/haiyou.jpg',
  },
  {
    title: '中国光大银行',
    desc: '光大银行携手小鱼易连，依托光大银行私有云环境，建设覆盖39家分行、1058家支行网点及619家社区银行的光大多媒体云视频会议系统，实现了对光大银行自有系统的集成。依托小鱼易连超强视频中台能力，全面开放API、SDK接口，打通光大银行App业务平台和办公系统，提升光大银行业务流程视频化、业务应用可视化，打破现有系统的内外部通讯孤岛，满足对内协同、对外沟通的多业务场景覆盖。',
    link: LINK_PRE_PATH + '6c26e3',
    logo: urlPre + 'cases/color/guangda.png',
    grayLogo: urlPre + 'cases/gray/guangda.png',
    img: urlPre + 'cases/guangda.jpg',
  },
  {
    title: '阳光保险集团股份有限公司',
    desc: '阳光保险携手小鱼易连，依托企业内网和互联网，构建阳光保险云视频会议系统，满足全集团的“点对点、多对多”互动云视频会议和大规模直播。小鱼易连全面开放的SDK能力，与阳光保险集团的移动办公平台阳光plus App打通，同时为集团打造了专属的“阳光云会议”PC客户端，让会议从会议室走向个人，实现数万人的高清互动云视频覆盖。',
    link: LINK_PRE_PATH + '1099',
    logo: urlPre + 'cases/color/yangguang.png',
    grayLogo: urlPre + 'cases/gray/yangguang.png',
    img: urlPre + 'cases/yangguang.jpg',
  },
];
